/* 🤖 this file was generated by svg-to-ts */
export const mgcIconFlashFilled: {
  name: 'flash-filled';
  data: string;
} = {
  name: 'flash-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13.714 1.037a1.45 1.45 0 0 0-.234.109c-.147.085-10.259 12.194-10.37 12.418a.992.992 0 0 0 .192 1.14c.304.305.203.296 3.507.296h2.915l-.022.13a479 479 0 0 0-.366 3.55c-.382 3.775-.376 3.596-.125 3.926.191.25.459.374.808.373.225 0 .316-.02.456-.1.138-.078 1.249-1.388 5.259-6.199 2.797-3.355 5.116-6.163 5.155-6.24a.994.994 0 0 0-.185-1.134C20.397 8.99 20.512 9 17.188 9h-2.917l.023-.13c.012-.071.178-1.669.369-3.55.383-3.775.377-3.596.126-3.926a1.01 1.01 0 0 0-.744-.38 1.223 1.223 0 0 0-.331.023"/></svg>`
};
